import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { modalUpdate } from "../../../../store/actions/settingsActions";

const ReissueTicketIcon = ({ width = 61, height = 60, color = "#626BE7" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 61 60">
    <path fill={color} d="M43.2 34.2h8.1v-5.1L60 37.8l-8.7 8.7v-5.1h-8.1c-3.1 0-5.6 2.5-5.6 5.6v2.8h-6.1V47c0-6.8 5-12.8 11.7-12.8z"/>
    <path fill={color} d="M17.9 46.5H9.8v5.1L1.1 42.9l8.7-8.7v5.1h8.1c3.1 0 5.6-2.5 5.6-5.6v-2.8h6.1v2.8c0 6.8-5 12.8-11.7 12.8z"/>
  </svg>
);

function ReissueTicket({ type }) {
  const dispatch = useDispatch();
  const { activeTicketId } = useSelector(state => state.tickets);

  const openReissue = () => {
    if (activeTicketId != null) {
      dispatch(modalUpdate({ visible: 1, content: "ReissueTicket", modalType: 1 }));
    }
  };

  if (type === "default") {
    return (
      <div className="home-left-content2-item item5 call-more" onClick={openReissue}>
        <ReissueTicketIcon />
        <h4>Re-Assign</h4>
      </div>
    );
  }

  return (
    <div className="actionButtonContainer">
      <div className="actionButton scheme-purple-bg" onClick={openReissue}>
        <div>
          <ReissueTicketIcon width={24} height={24} color="#F3F1FF" />
        </div>
        <span>Re-Assign</span>
      </div>
    </div>
  );
}

export default ReissueTicket;
